import { useHideDOMElement } from "./useHideDOMElement";

export const useHideHelpscout = () => {
  useHideDOMElement("#beacon-container");
};
